// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledUiTableRedux = styled('div')(
  () => css`
    .ui-sticky-table {
      width: 100%;
      margin-bottom: 16px;
      border-radius: 8px !important;
      box-shadow: 0px 3px 8px -1px rgba(50, 50, 71, 0.05),
        0px 0px 1px rgba(12, 26, 75, 0.24) !important;
      font-family: inherit !important;

      .MuiTable-root {
        tr {
          th {
            padding: 12px 12px;
            white-space: nowrap;
            background-color: unset !important;
            font-size: 1rem;
            font-weight: 800;
            font-family: inherit !important;
            border: none !important;
            background-color: #ffffff !important;
            white-space: nowrap;
            box-sizing: border-box;

            &:first-child {
              border-radius: 0px 8px 8px 0 !important;
            }

            &:last-child {
              border-radius: 8px 0px 0px 8px !important;
            }
          }

          td {
            font-family: inherit !important;
            border-bottom: unset !important;
            background-color: #ffffff !important;
            box-sizing: border-box;
            padding: 16px 12px;
            white-space: nowrap;
          }

          th:first-child,
          td:first-child {
            padding-right: 24px;
          }

          th:last-child,
          td:last-child {
            padding-left: 24px;
          }

          .checkbox-column {
            padding: 15px !important;
          }

          td.rowActions {
            display: flex;
          }
        }

        .MuiTableCell-stickyHeader {
          border-bottom: 1px solid #f5f5f5 !important;
        }
        .MuiTableBody-root.empty {
          height: 523px;

          .empty-text {
            display: flex;
            justify-content: center;
            color: #ccd5dc;
          }
        }
      }
    }

    .ui-table-actions-item {
      background: #ffffff;
      border: 1px solid #eeeeee;
      border-radius: 6px;
      padding: 8px;
      margin: 0px 7px;
      cursor: pointer;
      display: flex;
      width: 18px;
      height: 18px;
      align-items: center;
    }

    @media screen and (max-width: 900px) {
      .ui-sticky-table {
        .MuiTable-root {
          td.hide-in-mobile,
          td .hide-in-mobile,
          th.hide-in-mobile {
            display: none;
          }
        }
      }
    }

    @media screen and (max-width: 450px) {
      .ui-sticky-table {
        .MuiTable-root {
          .checkbox-column {
            display: none;
          }

          td:not(.hide-in-mobile):nth-child(2),
          th:not(.hide-in-mobile):nth-child(2) {
            padding-right: 24px !important;
          }
        }
      }

      .ui-table-caption {
        .select-all {
          visibility: hidden;
        }
      }
    }

    .ui-table-caption {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      color: #aaaaaa;

      .MuiCheckbox-root {
        margin-left: 16px;
      }

      &.hidden-checkbox {
        justify-content: flex-end;
        margin-bottom: 10px;
      }
    }
  `
);
